import React, { useEffect } from 'react';
import { Form } from 'react-bootstrap';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { resetPerformerFilter, setPerformerFilter, setPerformerOptions } from '../../../actions/filters';
import PropTypes from 'prop-types';

const PerformerFilter = ({list, performerFilter,
                          performerOptions, setPerformerOptions, resetPerformerFilter, setPerformerFilter}) => {

  useEffect(() => { setPerformerOptions(list); return resetPerformerFilter; }, []);

  useEffect(() => { setPerformerOptions(list); }, [list]);

  const handleFilterChange = (event) => {
    let filter = event.currentTarget.value;
    if (filter === '') filter = null;
    setPerformerFilter(filter);
  };

  const options = performerOptions.map(a => <option key={a.pk} value={a.pk}>{a.name} ({a.count})</option>)

  return <Form.Group controlId="filter.performer">
    <Form.Label>{gettext('Исполнитель')}</Form.Label>
    <Form.Control as='select' size='sm' value={performerFilter} onChange={handleFilterChange}>
      <option value={''}>{gettext('Все')}</option>
      {options}
    </Form.Control>
  </Form.Group>
}

let mapStateToProps = (state) => {
  return {
    performerFilter: state.filters.performerFilter,
    performerOptions: state.filters.performerOptions
  }
};

PerformerFilter.propTypes = {
  list: PropTypes.array.isRequired,
  performerFilter: PropTypes.string.isRequired,
  setPerformerFilter: PropTypes.func.isRequired,
  resetPerformerFilter: PropTypes.func.isRequired,
  setPerformerOptions: PropTypes.func.isRequired,
}

export default compose(
  connect(mapStateToProps, { setPerformerFilter, resetPerformerFilter, setPerformerOptions })
)(PerformerFilter);
